import EvaApp from "@eva/client/app/EvaApp";

let instance = new EvaApp();

export default instance;
